module.exports = __webpack_public_path__ + "static/img/silkway.6730fb16.svg";